import { FC } from 'react';
import {
  Icon,
  OverflowMenu,
  OverflowMenuItem,
  tailwindOverride,
  Typography,
} from '@getsynapse/design-system';
import { useQuickActions } from 'Pages/ProjectsListPage/hooks/useQuickActions/useQuickActions';
import ProjectSideDrawerToggle from 'Pages/ProjectsListPage/components/ProjectSideDrawerToggle';

interface QuickActionsProps {
  projectId: string;
}

const QuickActions: FC<QuickActionsProps> = ({ projectId }) => {
  const { quickActionsMenuItems, openProjectPanel, canViewProject } =
    useQuickActions({
      projectId,
    });
  return (
    <>
      {canViewProject && (
        <ProjectSideDrawerToggle
          projectId={projectId}
          onOpenProjectPanel={openProjectPanel}
        />
      )}
      {quickActionsMenuItems.length > 0 && (
        <OverflowMenu
          menuListProps={{
            className: tailwindOverride('z-50', 'relative'),
          }}
          menuButtonProps={{
            'aria-label': `consolidated-projects-quick-actions-menu-${projectId}`,
          }}
        >
          {quickActionsMenuItems.map((item) => (
            <OverflowMenuItem
              key={item.action}
              onClick={item.onSelect}
              className='flex items-center space-x-2 group'
              aria-label={`consolidated-projects-quick-actions-menu-${projectId}-${item.action}`}
            >
              <Icon
                name={item.iconName || ''}
                src={item.iconSrc || ''}
                className={tailwindOverride('text-lg', {
                  'text-xl': item.iconSrc,
                })}
              />
              <Typography
                variant='label'
                className={tailwindOverride(
                  'group-active:text-neutral-white',
                  'cursor-pointer'
                )}
              >
                {item.label}
              </Typography>
            </OverflowMenuItem>
          ))}
        </OverflowMenu>
      )}
    </>
  );
};

export default QuickActions;
